import { useEventBus, type EventBusKey } from '@vueuse/core';

export type AiAdvisorSubmitQueryPayload = {
  query: string;
};

// Typed channel for cross-component AI advisor messaging (e.g. the search bar
// asking the advisor chat to run a query). Replaces raw window CustomEvents.
const submitQueryKey: EventBusKey<AiAdvisorSubmitQueryPayload> = Symbol('ai-advisor:submit-query');

export const useAiAdvisorSubmitQueryBus = () => useEventBus(submitQueryKey);
